import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_COLOUR, dataRange, makeColourScale } from '../lib/model-colour';

/** The viewer's shared colour scale for the fences (also those drawn inside TerrainMesh); null = each model's own range. */
export const FenceColourContext = createContext(null);

/** The scale of a fence: the shared one, else the default table over the model's own data range. */
export function useFenceScale(entry, scale) {
  const shared = useContext(FenceColourContext);
  const chosen = scale || shared;
  return useMemo(() => chosen || makeColourScale(DEFAULT_COLOUR, dataRange(entry.cells)), [chosen, entry]);
}
